module.exports = __webpack_public_path__ + "img/three_col.97e067a9.svg";